import React from "react";
import { NavLink } from "react-router-dom";
import { NavItem } from "reactstrap";
import navList from "../../config/navList";
import config from "config";
import ProfileService from "../../services/profileService";
import {
  MODULE_ACL_SWITCH,
  ACL_MODULE_MAPPING,
} from "../../constants/RouteConstant";
import SideBarSubNav from "./SidebarSubNav";
import { IconSupport } from "../../components/Icons";

class SidebarNav extends React.Component {
  checkAccountIsLogin = () => {
    ProfileService.getMenu()
      .then((response) => {
        this.setState({ getMenuLoader: false });
        if (response && response.success === 1) {
          this.props.updateUserAndCompanyType(response.data || {});
        } else {
          window.location.href = config.storeFrontURL;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    const {
      moduleAcl = [],
      awardCheck,
      activeIntegration,
      allIntegrations,
    } = this.props;
    let moduleAclArray = moduleAcl.map((item) => item.module_id);
    !moduleAclArray.includes(ACL_MODULE_MAPPING.CAMPAIGN) &&
    moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK)
      ? moduleAclArray.push(ACL_MODULE_MAPPING.CAMPAIGN)
      : null;
    return null;
    return (
      <div className="main-nav">
        {navList.map((data, index) => {
          if (
            data.moduleId !== "AWARD" &&
            MODULE_ACL_SWITCH === true &&
            !moduleAclArray.includes(data.moduleId) &&
            data.name != "Home"
          ) {
            return;
          }

          //for award
          if (data.moduleId == "AWARD" && awardCheck == 0) {
            return;
          }

          if (data.subModules) {
            return (
              <SideBarSubNav
                {...this.props}
                navInfo={data}
                checkAccountIsLogin={this.checkAccountIsLogin}
              />
            );
          }

          return (
            <NavItem key={index}>
              <NavLink
                onClick={this.checkAccountIsLogin}
                to={data.link}
                activeClassName="active"
                className={"nav-link "}
              >
                <span>
                  <data.icon />
                </span>
                <span>{data.name}</span>
              </NavLink>
            </NavItem>
          );
        })}

        <NavItem>
          <a
            href="https://xoxoday.gitbook.io/plum/for-admins-1/getting-started"
            className={"nav-link "}
            target="_blank"
            rel="noreferrer"
          >
            <span>
              <IconSupport />
            </span>
            <span>Support</span>
          </a>
        </NavItem>

        <li className="nav-item noHover sidebar-intgrstion-title mt-3">
          <a style={{ fontSize: "12px" }} className="nav-link">
            Manage Integrations
          </a>
        </li>
        {allIntegrations.map((data, index) => {
          if (data.moduleId != "manage_integrations") {
            if (
              activeIntegration.filter((i) => i.app_code == data.moduleId)
                .length == 0
            ) {
              return;
            }
          }
          return (
            <NavItem key={index}>
              <NavLink
                onClick={this.checkAccountIsLogin}
                to={data.link}
                activeClassName="active"
                className={"nav-link "}
              >
                <span>
                  <img
                    src={data.icon}
                    style={{ width: "15px", height: "15px" }}
                  />
                </span>
                <span>{data.name}</span>
              </NavLink>
            </NavItem>
          );
        })}
      </div>
    );
  }
}

export default SidebarNav;
